@if (sessionModel.initialLoadStatus() !== LoadingStatus.LOADED) {
    <div class="greeting">
        <div class="greeting-text"
             [ngClass]="{'failed': sessionModel.initialLoadStatus() === LoadingStatus.FAILED}">
            <div class="greeting-text-line-1"
                 [innerHTML]="'woa.message.entry.starting.line1' | translate | html">
            </div>
            <div class="greeting-text-line-2"
                 [innerHTML]="'woa.message.entry.starting.line2' | translate | html">
            </div>
        </div>
    </div>
}
@if (loadingService.loading()) {
    <div class="loading"
         [ngClass]="{
             'with-indicator': indicatorVisible() && (sessionModel.initialLoadStatus() === LoadingStatus.LOADED || sessionModel.initialLoadStatus() === LoadingStatus.RELOADING)
         }">
        @if (sessionModel.initialLoadStatus() === LoadingStatus.LOADED || sessionModel.initialLoadStatus() === LoadingStatus.RELOADING) {
            <div [ngClass]="{
                     'with-quick-spinner': !indicatorVisible(),
                     'with-message': showMessages() && loadingService.loadingMessage()
                 }"
                class="loading-indicator">
                @if (indicatorVisible()) {
                    <svg class="loading-indicator-spinner"
                         height="140" width="140"
                         viewBox="0 0 140 140">
                        <defs>
                            <linearGradient id="loading-spinner-fade-gradient"
                                            gradientTransform="rotate(90)">
                                <stop offset="0" stop-color="black" stop-opacity="1"/>
                                <stop offset="1" stop-color="black" stop-opacity="0"/>
                            </linearGradient>
                            <mask id="loading-spinner-gradient-mask"
                                  maskUnits="userSpaceOnUse">
                                <rect width="100%" height="100%" fill="white"/>
                                <rect x="90" y="70" width="50" height="10" fill="url(#loading-spinner-fade-gradient)"/>
                            </mask>
                            <g id="loading-spinner-bite"
                               fill="black">
                                <circle r="2" cx="5" cy="3"/>
                                <circle r="3.5" cx="10" cy="2"/>
                                <circle r="3.5" cx="15" cy="2"/>
                                <circle r="2" cx="20" cy="3"/>
                                <circle r="2" cx="24" cy="3"/>
                                <rect x="0" y="2" width="32" height="20"/>
                            </g>
                            <mask id="loading-spinner-loading-spinner-bite-1-mask"
                                  maskUnits="userSpaceOnUse">
                                <rect width="100%" height="100%" fill="white"/>
                                <use xlink:href="#loading-spinner-bite"
                                     transform="translate(75, 39) rotate(-75) scale(1.1)"/>
                            </mask>
                            <mask id="loading-spinner-loading-spinner-bite-2-mask"
                                  maskUnits="userSpaceOnUse">
                                <rect width="100%" height="100%" fill="white"/>
                                <use xlink:href="#loading-spinner-bite"
                                     transform="translate(75, 39) rotate(-75) scale(1.2)"/>
                                <use xlink:href="#loading-spinner-bite"
                                     transform="translate(30, 107) rotate(19) scale(1.8)"/>
                            </mask>
                        </defs>
                        <g transform="rotate(-90, 70, 70)">
                            <animateTransform attributeName="transform"
                                              attributeType="XML"
                                              type="rotate"
                                              dur="3s"
                                              repeatCount="indefinite"
                                              keyTimes="0; 0.4; 0.8; 1"
                                              values="-90, 70, 70; -685, 70, 70; -685, 70, 70; -810, 70, 70"
                                              calcMode="spline"
                                              keySplines="0.5 0 0.5 1; 0.5 0 0.5 1; 0.5 0 0.5 1"/>
                            <g id="loading-spinner-bite-rocker">
                                <animateTransform attributeName="transform"
                                                  attributeType="XML"
                                                  type="rotate"
                                                  dur="3s"
                                                  repeatCount="indefinite"
                                                  keyTimes="0; 0.5; 0.52; 0.54; 0.56; 0.58; 1"
                                                  values="0, 110, 75; 0, 110, 75; -5, 110, 75; 0, 110, 75; 5, 110, 75; 0, 110, 75; 0, 110, 75"
                                                  calcMode="spline"
                                                  keySplines="0.5 0 0.5 1; 0.5 0 0.5 1; 0.5 0 0.5 1; 0.5 0 0.5 1; 0.5 0 0.5 1; 0.5 0 0.5 1"/>
                                <g id="logo">
                                    <animate attributeName="mask"
                                             dur="3s"
                                             repeatCount="indefinite"
                                             keyTimes="0; 0.2; 0.5; 0.54; 0.9; 1"
                                             values="url(#loading-spinner-gradient-mask); none; url(#loading-spinner-loading-spinner-bite-1-mask); url(#loading-spinner-loading-spinner-bite-2-mask); none; none"/>
                                    <circle r="45" cx="70" cy="70"
                                            stroke-dasharray="282"
                                            fill="none"
                                            stroke="var(--woa-chewzie-orange)"
                                            stroke-width="0">
                                        <animate attributeName="stroke-width"
                                                 dur="3s"
                                                 repeatCount="indefinite"
                                                 keyTimes="0; 0.4; 0.8; 1"
                                                 values="5; 25; 25; 10"
                                                 calcMode="spline"
                                                 keySplines="0.5 0 0.5 1; 0.5 0 0.5 1; 0.5 0 0.5 1"/>
                                        <animate attributeName="stroke-dashoffset"
                                                 dur="3s"
                                                 repeatCount="indefinite"
                                                 keyTimes="0; 0.4; 0.8; 1"
                                                 values="282; 50; 50; 282"
                                                 calcMode="spline"
                                                 keySplines="0.5 0 0.5 1; 0.5 0 0.5 1; 0.5 0 0.5 1"/>
                                    </circle>
                                    <g transform="translate(115, 71)">
                                        <polygon points="-20,0 0,-18 20,0"
                                                 fill="var(--woa-chewzie-orange)"
                                                 transform="scale(0)">
                                            <animateTransform attributeName="transform"
                                                              type="scale"
                                                              dur="3s"
                                                              repeatCount="indefinite"
                                                              keyTimes="0; 0.2; 0.4; 0.8; 0.9; 1"
                                                              values="0; 0; 1; 1; 0; 0"/>
                                        </polygon>
                                    </g>
                                </g>
                                <g id="crumbs-1"
                                   fill="var(--woa-chewzie-orange)"
                                   visibility="hidden"
                                   transform="translate(80, 20)">
                                    <animate attributeName="visibility"
                                             dur="3s"
                                             repeatCount="indefinite"
                                             keyTimes="0; 0.5; 0.8; 1"
                                             values="hidden; visible; hidden; hidden"/>
                                    <circle r="2.25" cx="5" cy="6">
                                        <animateMotion dur="3s"
                                                       repeatCount="indefinite"
                                                       keyTimes="0; 0.5; 0.56; 1"
                                                       keyPoints="0; 0; 1; 1"
                                                       calcMode="linear"
                                                       path="M0,0 L2,1"/>
                                    </circle>
                                    <circle r="3.0" cx="10" cy="16">
                                        <animateMotion dur="3s"
                                                       repeatCount="indefinite"
                                                       keyTimes="0; 0.5; 0.56; 1"
                                                       keyPoints="0; 0; 1; 1"
                                                       calcMode="linear"
                                                       path="M0,0 L2,-2"/>
                                    </circle>
                                    <circle r="2.5" cx="11" cy="1"/>
                                    <circle r="2.5" cx="19" cy="8"/>
                                    <circle r="2.25" cx="16" cy="25"/>
                                </g>
                                <g id="crumbs-2"
                                   fill="var(--woa-chewzie-orange)"
                                   visibility="hidden"
                                   transform="translate(40, 115)">
                                    <animate attributeName="visibility"
                                             dur="3s"
                                             repeatCount="indefinite"
                                             keyTimes="0; 0.54; 0.8; 1"
                                             values="hidden; visible; hidden; hidden"/>
                                    <animateMotion dur="3s"
                                                   repeatCount="indefinite"
                                                   keyTimes="0; 0.54; 0.56; 1"
                                                   keyPoints="0; 0; 1; 1"
                                                   calcMode="linear"
                                                   path="M0,0 L-2,3"/>
                                    <circle r="2.25" cx="2" cy="2"/>
                                    <circle r="3.0" cx="13" cy="5"/>
                                    <circle r="2.5" cx="23" cy="10"/>
                                    <circle r="2.25" cx="16" cy="14">
                                        <animateMotion dur="3s"
                                                       repeatCount="indefinite"
                                                       keyTimes="0; 0.54; 0.56; 1"
                                                       keyPoints="0; 0; 1; 1"
                                                       calcMode="linear"
                                                       path="M0,0 L-2,3"/>
                                    </circle>
                                </g>
                            </g>
                        </g>
                    </svg>
                } @else {
                    <woa-spinner class="loading-indicator-quick-spinner"></woa-spinner>
                }
                @if (showMessages() && loadingService.loadingMessage()) {
                    <div class="loading-indicator-message">
                        {{ loadingService.loadingMessage() }}
                    </div>
                }
            </div>
        }
    </div>
}

